export const REVOKE_ALL_SESSIONS_PATH = "/api/v1/users/me/sessions/revoke";

export async function revokeAllSessions(): Promise<boolean> {
  try {
    const { apiClient } = await import("@/lib/apiClient");
    await apiClient.post(REVOKE_ALL_SESSIONS_PATH, {});
    return true;
  } catch {
    return false;
  }
}
